const mobMenu = {
  nextLevel: document.querySelectorAll(".jsNextLevel") as NodeListOf<HTMLElement>,
  prevLevel: document.querySelectorAll(".jsPrevLevel") as NodeListOf<HTMLElement>,
  

  init() {
    this.setNextLevel()
    this.setPrevLevel()
  }, 
  setNextLevel() {
    this.nextLevel.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement
      if (subMenu) {
        item.addEventListener("click", (e) => {
          e.preventDefault()          
          subMenu.classList.add("activeClass")        
        })
      }
    })
  },
  setPrevLevel() {
    this.prevLevel.forEach((item) => {
      const menu = item.parentElement?.parentElement as HTMLElement
      if (menu) {
        item.addEventListener("click", () => {                  
          menu?.classList.remove("activeClass")        
        })
      }
    })
  },
}

export default mobMenu
